import { Component, Input } from '@angular/core';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { DocumentService, FieldSchema, Document } from '@lsq-frontend/remote-services/ar-app';
import { flatten } from 'lodash';
import { DrApplicationService } from '../../service/dr-application-service';

@Component({
    selector: 'dr-download-all-documents-field',
    templateUrl: './dr-download-all-documents-field.component.html',
    styleUrls: ['./dr-download-all-documents-field.component.scss']
})
export class DownloadAllDocumentsField {
    @Input() prospectDataId: string;
    @Input() label: string;

    constructor(
        private _arService: DrApplicationService,
        private _documentService: DocumentService,
        private _alertService: AlertService
    ) {}

    public getDocuments() {
        const stageSchemaDocumentId = this._arService.getDocumentsStageID();
        const stageSchemas = this._arService.getProspectSchema().stageSchemas;
        const documentStageSchema = stageSchemas.filter(
            (stageSchema) => stageSchema.id === stageSchemaDocumentId
        );
        const documentFieldSchemas: FieldSchema[] = documentStageSchema[0].fieldSchemas.filter(
            (fieldSchema: FieldSchema) =>
                fieldSchema.fieldType === FieldSchema.FieldTypeEnum.DocumentField
        );
        const fields = this._arService.getProspect().stages[stageSchemaDocumentId].fields;
        const documents = documentFieldSchemas.map((fieldSchema: FieldSchema) => {
            const documentField = fields[fieldSchema.id];
            const hasDocument =
                documentField !== undefined &&
                !!documentField.fieldValue &&
                Array.isArray(documentField.fieldValue) &&
                documentField.fieldValue.length > 0;
            console.log(hasDocument);
            if (!hasDocument) {
                return null;
            } else if (!hasDocument) {
                return [
                    {
                        hasDocumentField: false,
                        fieldLabel: fieldSchema.label,
                        id: fieldSchema.id
                    }
                ];
            }
            const documentInstances = documentField.fieldValue.map(
                (documentInstance: Document) => ({
                    hasDocumentField: true,
                    ...documentInstance,
                    fieldLabel: fieldSchema.label,
                    id: fieldSchema.id
                })
            );
            return documentInstances;
        });
        let documentTableFlatten = flatten(documents);

        documentTableFlatten = documentTableFlatten.filter((documentTable) => !!documentTable);
        return documentTableFlatten;
    }

    public async downloadAll(): Promise<void> {
        const docs = this.getDocuments().filter((doc) => !!doc.documentId);
        await Promise.all(
            docs.map(async (doc) =>
                this._arService.downloadDocument(
                    (doc as Document).documentId,
                    (doc as Document).fileName
                )
            )
        );
    }
}
